export default "__VITE_ASSET__WH58EyGM__"